<template>
    <Dialog
        v-model:visible="visible"
        modal
        :closable="false"
        header="Unconfirmed Incident Created"
        :style="{ width: '25rem' }"
    >
        <span class="p-text-secondary block mb-5"
            >An unconfirmed <b>ACTIVE SHOOTER</b> incident has been
            reported.</span
        >

        <div class="flex justify-content-end gap-2">
            <Button
                type="button"
                label="View Incident"
                @click="visible = false"
            ></Button>
        </div>
    </Dialog>
</template>

<script setup>
import { ref } from "vue";

const visible = ref(false);
const emit = defineEmits(["closed"]);

defineExpose({
    show,
    hide,
});

function hide() {
    visible = false;
}

function show() {
    console.log("show primarynotification");
    visible.value = true;
}
</script>
